import React from "react"


export default class EmailCampaignErrors extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
    if (!jQuery.isEmptyObject(this.props.errors)) {
    	var idx = 0;
    	var errors = Object.keys(this.props.errors).map((key, idx) => {
        return <li key={idx}>{key + " " + this.props.errors[key]}</li>
    	});

      return (
      	<div className="alert alert-danger">
      		<ul>{errors}</ul>
      	</div>
      );
    } else {
    	return null;
    }
	}

}
